<div [attr.data-automation-e2e-state]="show ? 'noData' : 'hasData'"
    class="style-height-width-100 container">
    <div [ngClass]="show ? 'show' : 'hide'">
        <ng-content></ng-content>
    </div>
    <div *ngIf="show"
         class="pill">
        <span [textContent]="message"></span>
    </div>
</div>
